import { useRef, useEffect } from "react"
import { useInView, useAnimation } from "framer-motion"


export const headingAnimation={
    hidden:{
        opacity:0,
        y:20
    },
    show:{
        opacity:1,
        y:0,
        transition:{
            duration:0.5
        }
    }
}

export const teamCardAnimation={
    hidden:{
        opacity:0,
    },
    show:{
        opacity:1
    }
}

export const useAnimationHook=(amount)=>{
    const ref = useRef(null)
    const isInView = useInView(ref, {once:true, amount:amount})
    const mainControls=useAnimation()
    useEffect(()=>{
        if (isInView) {
            mainControls.start("show")
        }
    }, [isInView, mainControls])
    return {ref, mainControls}
}

// popup variant
export const sidePopup={
    open:{
      x:"0",
      transition: {
        delay:0.02,
        duration: 0.5,
        ease: "easeInOut",
      },
    },
    close:{
      x: "110vh",
      transition: {
        delay:0.02,
        duration: 0.5,
        ease: "easeInOut",
      },
    }
}